var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodiMonthlyMileage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_685",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7302 0H0V19.7302H19.7302V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8772 18.0864V4.11081C2.8772 2.46662 3.9788 1.64453 5.34348 1.64453H11.9202C13.2849 1.64453 14.3865 2.46662 14.3865 4.11081V18.0864H2.8772Z",
    stroke: "black",
    strokeWidth: 1.23314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64404 18.0859H15.6196",
    stroke: "black",
    strokeWidth: 1.23314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89726 8.2212H10.3747C11.2297 8.2212 11.9285 7.81018 11.9285 6.66747V5.65629C11.9285 4.51359 11.2297 4.10254 10.3747 4.10254H6.89726C6.04229 4.10254 5.34351 4.51359 5.34351 5.65629V6.66747C5.34351 7.81018 6.04229 8.2212 6.89726 8.2212Z",
    stroke: "black",
    strokeWidth: 1.23314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34351 10.6875H7.80978",
    stroke: "black",
    strokeWidth: 1.23314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3865 13.1623L18.0859 13.1541V8.22151L16.4417 7.39941",
    stroke: "black",
    strokeWidth: 1.23314,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodiMonthlyMileage);
export default __webpack_public_path__ + "static/media/CodiMonthlyMileage.91db3453ac47764513ff57c3b374dbc3.svg";
export { ForwardRef as ReactComponent };